// Gentle reveal on scroll for Riverium sections. Content is never hidden when this script does not run.
(function () {
  var items = document.querySelectorAll('.rv-reveal');
  if (!items.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('rv-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('rv-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  items.forEach(function (el, i) {
    el.style.transitionDelay = (i % 6) * 70 + 'ms';
    io.observe(el);
  });
})();
